import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgFinancial = function SvgFinancial(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_129_7687",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_129_7687)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#1894E8",
        fillOpacity: 0.15,
        d: "M46.051 12.064 71.397 25.04q.312.143.56.495.248.351.248.819a.9.9 0 0 1-.308.71q-.307.27-.769.27h-54.32q-.372 0-.693-.27a.88.88 0 0 1-.32-.71q0-.468.285-.77.286-.3.67-.544l25.199-12.975a4.54 4.54 0 0 1 2.043-.474q1.085 0 2.06.474M26.51 61.829q.355.357.924.357.35 0 .656-.186h15.34q.299.186.709.186.396 0 .699-.186h15.015q.3.186.709.186.55 0 .917-.356.367-.355.367-.843v-.217c.1-.237.154-.497.154-.77V35c0-.315-.073-.613-.202-.878a1.2 1.2 0 0 0-.308-.534 1.2 1.2 0 0 0-.397-.263A2 2 0 0 0 60 33H28c-.414 0-.8.126-1.119.342q-.197.087-.36.245-.261.253-.337.573c-.118.256-.184.54-.184.84v25c0 .273.055.533.154.77v.134q0 .567.356.925M16.15 70.248q.357.4.844.4h53.93q.566-.001.924-.356.357-.356.357-.924 0-.55-.356-.917a1.13 1.13 0 0 0-.843-.368h-53.93q-.566 0-.924.356-.357.356-.357.924 0 .484.356.885"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_129_7687)",
        d: "M23.434 58.186q-.57 0-.924-.357-.357-.358-.356-.925V30.43q0-.488.367-.843.368-.356.917-.356.569 0 .924.357.356.358.356.925v26.474q0 .488-.4.843a1.3 1.3 0 0 1-.884.356m16.705 0q-.57 0-.924-.357-.356-.358-.356-.925V30.43q0-.488.4-.843a1.3 1.3 0 0 1 .884-.356q.57 0 .924.357.356.358.356.925v26.474q0 .488-.368.843-.367.357-.916.356m-27.145 8.462q-.487 0-.843-.4a1.3 1.3 0 0 1-.356-.885q0-.568.357-.924.358-.355.925-.355h53.93q.486 0 .842.367t.356.917q0 .569-.357.924-.358.356-.925.356zm43.568-8.462q-.569 0-.924-.357-.356-.358-.356-.925V30.43q0-.488.4-.843a1.3 1.3 0 0 1 .884-.356q.57 0 .924.357.357.358.356.925v26.474q0 .488-.367.843-.368.357-.917.356M42.052 8.064 67.396 21.04q.312.143.56.495.248.351.248.819a.9.9 0 0 1-.308.71q-.307.27-.769.27h-54.32q-.372 0-.693-.27a.88.88 0 0 1-.32-.71q0-.468.285-.77.285-.3.67-.544L37.949 8.064a4.54 4.54 0 0 1 2.043-.474q1.085 0 2.06.474M18.922 20.77h42.154L40 9.962z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_129_7687",
        x1: 12.384,
        x2: 67.42,
        y1: 37.118,
        y2: 37.118,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgFinancial as ReactComponent };
//# sourceMappingURL=Financial.svg.es.js.map
